import { ACCESS_CONTROL_MATRIX, AccessControlAction } from '@/constants';
import { selectUserAboutData, useAppSelector } from '@/store';

export const useAccessControl = (action: AccessControlAction): boolean => {
  const userAboutData = useAppSelector(selectUserAboutData);
  if (!userAboutData || !userAboutData.role || !ACCESS_CONTROL_MATRIX[userAboutData.role]) {
    return false;
  }

  return ACCESS_CONTROL_MATRIX[userAboutData.role][action] || false;
};
